import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environment';

import { LoginService } from '@core/services/login/login.service';
import { UtilityService } from '@core/services/util/utility.service';

@Injectable({
    providedIn: 'root'
})

export class FaqService {

    constructor(
        private http: HttpClient,
        private loginService: LoginService,
        private utilityService: UtilityService
    ) {
    }

    async fetchDetails(status?) {
        const params = {
            brand_id: environment.brand.id
        };
        if (status) {
            params['order_status'] = status
        }

        await this.loginService.ensureSessionId(true);
        const headers = this.utilityService.getAuthHeaders();

        return this.http.get(environment.apiUrl + '/faq/faq_details', {
            params, headers
        });
    }
}